import type { AllRouteEndpoints } from "../routeTypes";
import { appSettingsCustomAttributesData } from "@dashboardApi/apis/appSettingsCustomAttributesData";
export const appsAppGroupIdCustomAttributesSettingsCreateCacheKeys: AllRouteEndpoints[] = [
  appSettingsCustomAttributesData,
];
